import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { REFERRAL_TOKEN_KEY } from 'products/nomad_insurance/constants';
import { registerLinkClickedV2 } from '../state/referrals';

const useReferralToken = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.app.user);

  function saveRegisterLinkClickedV2(referralToken) {
    dispatch(registerLinkClickedV2(referralToken));
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referralToken =
      queryParams.get(REFERRAL_TOKEN_KEY) || localStorage.getItem(REFERRAL_TOKEN_KEY);

    if (referralToken) {
      if (isAuthenticated) {
        saveRegisterLinkClickedV2(referralToken);
      } else {
        localStorage.setItem(REFERRAL_TOKEN_KEY, referralToken);
      }
    }
  }, [location, isAuthenticated]);
};

export default useReferralToken;
